export default __webpack_public_path__ + "static/media/waves.68ae1c3f.svg";